import * as React from "react";
import { PhoneCall, Truck, Wrench, Car, FileText, Bell } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const benefitsData = [{
  title: "Expert Consultation",
  description: "Direct access to our senior inspectors for detailed clarification on any complex report findings or structural concerns.",
  icon: PhoneCall
}, {
  title: "On-Site Efficiency",
  description: "Our mobile inspection units are fully equipped with advanced diagnostic tools to provide comprehensive site evaluations.",
  icon: Truck
}, {
  title: "Technical Precision",
  description: "Utilizing thermal imaging and moisture detection technology to identify hidden defects invisible to the naked eye.",
  icon: Wrench
}, {
  title: "Rapid Response",
  description: "Priority scheduling and streamlined workflows ensuring your full inspection report is delivered within 24 to 48 hours.",
  icon: Car
}, {
  title: "Digital Reporting",
  description: "High-resolution, cloud-based interactive reports featuring 360-degree imagery and prioritized action items.",
  icon: FileText
}, {
  title: "Status Updates",
  description: "Proactive real-time notifications tracking every stage of your inspection from arrival to final report generation.",
  icon: Bell
}];
export default function Benefits() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="38539" id="why-choose-trusted-inspections" className="relative w-full py-32 bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center overflow-hidden opacity-[0.03]">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/image_n2hc3lg2.png" alt="" className="w-[800px] h-[800px] object-contain grayscale rotate-12" />
      </div>

      <div className="container relative mx-auto px-4 md:px-6 max-w-7xl">
        <div ref={ref} className={cn("space-y-12 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          
          {}
          <div className="text-center max-w-3xl mx-auto space-y-4">
            <h2 className="text-3xl md:text-5xl font-bold tracking-tighter text-secondary uppercase">
              Why Trust Us
            </h2>
            <p className="text-lg text-muted-foreground">
              Unrivaled expertise and precision in property inspections to protect your investments and provide total clarity.
            </p>
          </div>

          {}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {benefitsData.map((benefit, index) => <div key={index} data-index={index} className="h-full">
                <Card className="group h-full border-none bg-white rounded-lg transition-all duration-300 hover:-translate-y-1 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.05)] hover:shadow-xl">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-xl bg-primary/10 text-primary transition-colors group-hover:bg-primary/20">
                      <benefit.icon className="h-8 w-8" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-lg font-bold uppercase tracking-wider text-secondary transition-colors">
                      {benefit.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base leading-relaxed text-muted-foreground">
                      {benefit.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>)}
          </div>

        </div>
      </div>
    </section>;
}